//import { saveAppState } from "index.js";
import { setStateScope, setStateSWLoaded } from "store/store";


export async function register(config) {
  console.log('SW register', process.env.NODE_ENV);

  if (!('serviceWorker' in navigator)) {
    setStateSWLoaded(false);
    //saveAppState();
    console.log('Service Worker not supported!');
    return;
  }

  var done = false;
  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
  console.log('SW register', swUrl);
  await navigator.serviceWorker.register(swUrl)
    .then((sw) => {
      console.log('SW Registered: ', sw);
      setStateScope(sw.scope);
      setStateSWLoaded(true);
      //saveAppState();
      done = true;
    })
    .catch((err) => {
      console.log('SW Register error:', err);
      setStateSWLoaded(false);
      //saveAppState();
    })
    .finally(() => {
      console.log('SW Register final');
    });

    if (done) {
      console.log('SW register done');
      return;
    }

    console.log('SW ready');
    await navigator.serviceWorker.ready
    .then((sw) => {
      console.log('navigator.serviceWorker.ready', sw);
      setStateScope(sw.scope);
      setStateSWLoaded(true);
      //saveAppState();
    })
    .catch((err) => {
      console.log('SW ready error', err);
    })
    .finally(() => {
      console.log('SW Ready final');
    });
  }
